import { render, staticRenderFns } from "./JianKang_survey.vue?vue&type=template&id=b82220ba&scoped=true"
import script from "./JianKang_survey.vue?vue&type=script&lang=js"
export * from "./JianKang_survey.vue?vue&type=script&lang=js"
import style0 from "./JianKang_survey.vue?vue&type=style&index=0&id=b82220ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82220ba",
  null
  
)

export default component.exports